module.exports = __webpack_public_path__ + "static/media/time-bomb.dbd9854f.svg";